import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";

import { COMMON_STATUS } from "../constants/status";
import SettingsService from "../service/SettingsService";

import { RootState } from "../store/store";
import { logoutUser } from "./common";
import { LocalNowModel } from "../model/common";
import moment from "moment";


export const resetLocalNow = createAction("localNow/reset")

const _service = new SettingsService();

type SliceState = { value: LocalNowModel, status: string, apiCallCount: number }

const initialState = {
  value: {},
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0
} as SliceState;

export const getLocalNowAsync = createAsyncThunk(
  "localNow/get",
  async (params: any) => {
    const response = await _service.getLocalNowService(params);
    return response;
  }
);


export const localnowSlice = createSlice({
  name: "localNow",
  initialState,
  reducers: {
    setLocalNowStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocalNowAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getLocalNowAsync.fulfilled, (state, action) => {
        let gap = moment.duration(moment().diff(action.payload)).asHours();
        gap = Math.floor(gap);
        const clientNow = moment(action.payload);
        clientNow.add(gap, "hour").utc(true);
        state.value = {
          localServerNow: action.payload,
          hourGapBetweenClient: gap,
          localClientNow: clientNow.toDate()
        };
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getLocalNowAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetLocalNow, () => {
        return initialState;
      });
  },
});

export const { setLocalNowStatus } = localnowSlice.actions;
export const getLocalNowInfo = (state: RootState) => state.localNow.value;
export const getLocalNowStatus = (state: RootState) => state.localNow.status;
export default localnowSlice.reducer;